import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyString } from "../../RadObject";
import { ClientAwareCategoryAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareCategoryAttribute";
import { ClientAwareDisplayNameAttribute } from "../../Server/DotNet/SeriouslyRAD.Framework/ClientAwareDisplayNameAttribute";
import { ITableColumnBase, TableCell, TableColumnBase, TableColumnBasePropertyValues } from "./Table";
import { NAMESPACE } from "./_Namespace";

export type TableColumnPropertyValues =
    TableColumnBasePropertyValues
    & {
        dataSourceProperty: string;
        formatString: string;
    };

export type TableColumnProperties = {
    [name in keyof TableColumnPropertyValues]: Property<TableColumnPropertyValues[name]>
};

export interface ITableColumn extends ITableColumnBase, TableColumnProperties
{
}

export class TableColumn extends TableColumnBase implements ITableColumn
{
    // #region Static

    public static override classNamespace = NAMESPACE + "TableColumn";
    public static override className = "TableColumn";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<TableColumnPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                tableCellClass: TableCell,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Properties

    public dataSourceProperty!: PropertyString;
    public formatString!: PropertyString;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TableColumnPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-table-column-text");
    }

    // #endregion

    // #region Protected Methods

    protected _dataSourcePropertyChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }
    protected _formatStringChanged(change: PropertyChange<string>)
    {
        /* Intentionally empty */
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: TableColumnPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.dataSourceProperty = new PropertyString({
            context: this,
            initialValue: propertyValues.dataSourceProperty,
            changeHandler: this._dataSourcePropertyChanged,
            attributes: [
                new ClientAwareCategoryAttribute({ category: "Data" }),
                new ClientAwareDisplayNameAttribute({ displayName: "Data Source Property" }),
            ],
        });
        this.formatString = new PropertyString(this, propertyValues.formatString, this._formatStringChanged);
    }

    protected override _textChanged(change: PropertyChange<string>)
    {
        super._textChanged(change);
        this._containerElementRef.current.text(change.currentValue);
    }

    // #endregion

    // #endregion
}